 // tabbed content
    // http://www.entheosweb.com/tutorials/css/tabs.asp
    $(".tab_content").hide();
    $(".tab_content:first").show();

  /* if in tab mode */
    $("ul.tabs li").click(function() {
        
      $(".tab_content").hide();
      var activeTab = $(this).attr("rel"); 
      $("#"+activeTab).fadeIn();        
        
      $("ul.tabs li").removeClass("active");
      $(this).addClass("active");

      $(".tab_drawer_heading").removeClass("d_active");
      $(".tab_drawer_heading[rel^='"+activeTab+"']").addClass("d_active");
      
    });
    /* if in drawer mode */
    $(".tab_drawer_heading").click(function() {
      
      $(".tab_content").hide();
      var d_activeTab = $(this).attr("rel"); 
      $("#"+d_activeTab).fadeIn();
      
      $(".tab_drawer_heading").removeClass("d_active");
      $(this).addClass("d_active");
      
      $("ul.tabs li").removeClass("active");
      $("ul.tabs li[rel^='"+d_activeTab+"']").addClass("active");
    });
    
    
    /* Extra class "tab_last" 
       to add border to right side
       of last tab */
    $('ul.tabs li').last().addClass("tab_last");

    $('select[name="change-pet"]').on('change', function() {
        var $this = $(this);
        $('select[name="change-pet"] > option:selected').each(function() {
            var pet_id = $(this).val();
            // Get URL from parent div's input field
            var changeUrl = $this.parent('div.switch-pets').find('input[name="onPetChangeUrl"]').val();
            if ( changeUrl !== undefined && changeUrl !== '' ) {
                window.location.replace(changeUrl + pet_id);
            }
        });
    });

    $.each( $('form.reply-to-form'), function () {
        var $form = $(this);
        $form.submit(function(e) {
            $.ajax({
                type: $form.attr('method'),
                url: $form.attr('action'),
                data: $form.serialize(),
                success: function (data) {
                    var $replyTo = "<div class='message-replies'><p class='message-reply'>Reply: <span class='reply-message-body'>"+ data.data.message +"</span></p></div>";
                    var $singleMessage = $form.parent('div.reply-input').parent('div.reply-to-message').parent('div.single-message');
                    $form.parent('div.reply-input').parent('div.reply-to-message').before($replyTo);
                    $form.parent('div.reply-input').parent('div.reply-to-message').find('input[name="message"]').val('');
                    $singleMessage.addClass('message-replied');
                }
            });
            e.preventDefault();
        });
    });

    var flagMessage = function(e) {
        e.preventDefault();
        var that = this;
        var message_id = $(that).parents('div.single-message').find('span.message-id').text().trim();
        if ( typeof message_id !== 'undefined' && message_id.length > 0 ) {
            $.ajax({
                type: 'GET',
                url: '/petchat/messages/flag/' + message_id,
                success: function (data) {
                    console.log(data);
                    if ( typeof data.status !== 'undefined' && data.status === 'success' ) {
                        console.log('Success');
                        $(that).parents('div.single-message').remove();
                    }
                }
            });
        }
        return false;
    }
    $('form.reply-to-form').on('keyup keypress', 
            function(e) {
                var keyCode = e.keyCode || e.which;
                if (keyCode === 13) {
                    e.preventDefault();
                    return false;
                }
            }     
    );
    $('button.flag_qa_message').on('click', flagMessage);

    $(document).ready(function() {
        if (typeof hj !== 'undefined') {
            var $apps = $('div.single-application');
            var showModal = false;
            $.each($apps, function(k,v) {
                if (!$(v).hasClass('unseen')) {
                    hj('trigger', 'would_you_recommend');
                    return false;
                }
            });
        }
    });

    var maybeHideImageUploadButton = function() {
        var $button = $('#image-upload');
        var $photos = $('.edit-gallery');
        if ( $button.length > 0 ) {
            if ( $photos.length === 4 ) {
                $button.prop('disabled', 'true');
            } else {
                $button.removeProp('disabled');
            }
        }
    }

    var imageUploadHandler = function($field) {

    }

    var imageUploadButtonInit = function() {

    }


    maybeHideImageUploadButton();
    imageUploadButtonInit();

